import type { PostCommentsData } from '@/types';
import { CommentButton } from '@/ui/CommentButton';
import { TooltipWrapper } from '@/ui/TooltipWrapper';
import * as styles from '../PostActions.css';

interface CommentActionWithTooltipProps {
  translations?: Record<string, string>;
  data: PostCommentsData;
  onClick?: () => void;
}

export const CommentActionButton = ({ onClick, translations, ...props }: CommentActionWithTooltipProps) => {
  if (translations?.['search.pagination.comment']) {
    return (
      <TooltipWrapper portalId="post-actions-container" tooltipText={translations['search.pagination.comment']}>
        <CommentButton onClick={onClick} styles={styles} data={props.data} />
      </TooltipWrapper>
    );
  }

  return <CommentButton onClick={onClick} data={props.data} styles={styles} />;
};
